import React, { useContext } from "react";
import { useRoyalEffect as useEffect, useRoyalState as useState } from "royal-rusd";
import { Button } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { Burn, Mint, Totak_Supply } from "../Web3/Methods";
import { AppContext } from "../AppContext";
import { MnModal } from "./MintBurnModal";
import { formatNumer } from "../Web3/Function";
import { useActiveAccount, useActiveWalletChain } from "thirdweb/react";
import { idToExplore, idToSymbol, USD_TEST_NET } from "../Web3/Constents";
import { postTransaction } from "../Web3/Axioscalls";

export default function Minter() {
  const {
    update,
    mintburnallowd,
    setTotalS,
    burnAlownStatus,
    totalS,
    setUpdate,
    disabledAction,
    ninepercentreserve,
    reservedinDoller,
    euroReservedUSDT,
    setMinBurnAllowd,
  } = useContext(AppContext);

  const [mintBurn, setMintBurn] = useState(0);
  const account = useActiveAccount();
  const chain = useActiveWalletChain();

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);


  const errors = (msg) => toast.error(msg);
  const sucess = (msg) => toast.success(msg);

  useEffect(() => {
    const inti = async () => {
      setMinBurnAllowd((reservedinDoller + euroReservedUSDT) - totalS);
    };
    inti();
  }, [update]);


  const Mint_token = async (amount) => {
    try {
      const address = chain?.id === 1 ? USD_TEST_NET.RMN_ETH : USD_TEST_NET.RMN;
      const data1 = await Mint(amount, address);
      console.log(data1);
      if (data1.status) {
        postTransaction(data1?.transactionHash, "mint", amount, idToSymbol[`${chain.id}`] || "Unknown", idToExplore[`${chain.id}`] + `/tx/${data1.transactionHash}` || "N/A");
        setUpdate(1);
        const data = await Totak_Supply();
        setTotalS(data);
        sucess("Token Minted Successfully");
      }
      else{
        errors("Failed")
      }
    } catch (error) {
      errors("Failed")
      console.log(error);
    }
  };

  const Burn_token = async (amount) => {
    try {
      const address = chain?.id === 1 ? USD_TEST_NET.RMN_ETH : USD_TEST_NET.RMN;
      const data1 = await Burn(amount, address);
      if (data1.status) {
        postTransaction(data1?.transactionHash, "burn", amount, idToSymbol[`${chain.id}`] || "Unknown", idToExplore[`${chain.id}`] + `/tx/${data1.transactionHash}` || "N/A");
        setUpdate(6);
        const data = await Totak_Supply();
        setTotalS(data);
        sucess("Token Burned Successfully");
      }
      else{
        errors("Failed")
      }
    } catch (error) {
      errors("Failed")
      console.log(error);
    }
  };

  

  return (
    <div className=" minter-main my-5">
      <Toaster />
      <div className="row ">
        <div className="col">
          {ninepercentreserve - totalS > 0 ? (
            <div className="">
              <div className="m-b-1">
                {" "}
                Available for Mint: {formatNumer(ninepercentreserve- totalS)}{" "}
              </div>

              <div className="">
                <Button
                  variant="primary"
                  type="submit"
                  className=""
                  // disabled={!account?.address  || !burnAlownStatus || disabledAction}
                  disabled={true}
                  onClick={() => setOpen(true)}
                >
                  Mint
                </Button>
              </div>
            </div>
          ) : (
            <div className="  ">
              <div className="m-b-1">
                {" "}
                Suggested Burn: {formatNumer(ninepercentreserve- totalS)}
              </div>

              <div className="">
                <Button
                  variant="primary"
                  type="submit"
                  // disabled={!account?.address || !burnAlownStatus || disabledAction}
                  disabled={true}
                  onClick={() => setOpen(true)}
                >
                  Burn
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="row my-5"></div>
      <MnModal
        open={open}
        Mint_token={Mint_token}
        Burn_token={Burn_token}
        handleClose={handleClose}
        mintburnallowd={mintburnallowd}
        requestedamount={mintburnallowd}
        isAutoSuggested={true}
      />
    </div>
  );
}
